var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 110,
    viewBox: "0 0 145 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2287 48.9736L64.4375 66.7158H83.0526L78.7795 48.9736H67.2287Z",
    fill: "#CCD6DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3725 63.5996H60.1855V69.3039H86.3725V63.5996Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.179 0H30V55.348H115.179V0Z",
    fill: "#CCD6DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.748 2.87305H33.0547V47.1981H111.748V2.87305Z",
    fill: "#003353"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5728 52.6281C74.4641 52.6281 75.1867 51.9055 75.1867 51.0142C75.1867 50.1229 74.4641 49.4004 73.5728 49.4004C72.6815 49.4004 71.959 50.1229 71.959 51.0142C71.959 51.9055 72.6815 52.6281 73.5728 52.6281Z",
    fill: "#A5A5A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 71H7V110H15V71Z",
    fill: "#C9C9C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138 71H130V110H138V71Z",
    fill: "#C9C9C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145 65H0V71H145V65Z",
    fill: "#C9C9C9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComputer);
export default __webpack_public_path__ + "static/media/IconComputer.711c7ed3.svg";
export { ForwardRef as ReactComponent };